import api from "@/lib/api";

export const getAllUser = async () => {
  const res = await api.post("/user/getAll");
  return res.data;
};

export const getUserDashboard = async () => {
  const res = await api.post("/user/dashboard");
  return res.data;
};

export const getUserById = async (id) => {
  const res = await api.post("/user/getUserById", { id });
  return res.data;
};

export const getAllRoles = async () => {
  const res = await api.post("/user/getAllRoles");
  return res.data;
};

export const deleteUser = async (id) => {
  const res = await api.post("/user/delete", { id });
  return res.data;
};

export const suspendUser = async (id) => {
  const res = await api.post("/user/suspend", { id });
  return res.data;
};

export const activateUser = async (id) => {
  const res = await api.post("/user/activate", { id });
  return res.data;
};

export const changeUserRole = async ({ id, role_id }) => {
  const res = await api.post("/user/changeRole", { id, role_id });
  return res.data;
};

export const updateUserEmail = async ({ id, email }) => {
  const res = await api.post("/user/updateEmail", { id, email });
  return res.data;
};


export const setupMFA = async () => {
  const res = await api.post("/user/setupMFA");
  return res.data;
};


// Call after setupMFA + user enters OTP from authenticator
export const enableMFA = async (otp) => {
  const res = await api.post("/user/enableMFA", { otp });
  return res.data;
};

// Call on login when MFA is already enabled
export const mfaVerify = async ({ challenge_token, otp }) => {
  const res = await api.post("/user/mfaVerify", { challenge_token, otp });
  return res.data;
};